import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReportService } from '@app/shared/services/report/report.service';
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import { environment } from '@env/environment';
//
import { Observable, Subscription } from 'rxjs';
export interface TreeNode {
  children: TreeNode[];
  cssClass?: string;
  css?: string;
  isParent: boolean;
  id: number;
}
interface MyTreeNode extends TreeNode {
  name: string;
  description?: string;
  price: string;
  image?: string;
  children: MyTreeNode[];
  owner_type: string;
  owner_profile_image_path: string;
  isActive: boolean;
  is_active: boolean;
  userListCount: number | 0;
  parentId: number | null;

  images?: Array<{
    img: string;
    price: string;
    name: string;
    position?: number | string;
    createdDate?: Date;
  }>;
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'small-asset-map-chart',
  templateUrl: './small-asset-map-chart.component.html',
  styleUrls: ['./small-asset-map-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallAssetMapChartComponent implements OnInit, OnDestroy {
  @Input() report_execution_id;
  @Input() isFromHomePage?: boolean = false;
  resizeObservable$: Observable<Event>;
  treeList = [];
  showZeroState = false;
  subscription = new Subscription();
  showHiddenListGroup = [];
  tree = [];

  // Worker references for proper cleanup
  private activeWorkers: Map<string, Worker> = new Map();

  constructor(private changeDetector: ChangeDetectorRef, private _reportService: ReportService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate all active workers
    this.activeWorkers.forEach((worker, id) => {
      worker.terminate();
    });
    this.activeWorkers.clear();
  }

  ngOnInit(): void {
    // this.showZeroState = true;
    this.getReportOwnerId(this.report_execution_id);
  }

  async getReportOwnerId(report_id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `report-owner-${Date.now()}-${Math.random()}`;
        const worker = new Worker(
          new URL('../../../../../../modules/reports/components/asset-map-container/get-report-data-by-owner-id.worker', import.meta.url),
          { type: 'module' }
        );
        this.activeWorkers.set(workerId, worker);

        let data = {
          token: '',
          url: '',
          report_execution_id: report_id,
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/report/report-execution-asset-map-owners-card`;
        let date = new Date();
        worker.onmessage = ({ data }) => {
          if (data.status == 200 || data.status == 201) {
            data.data.forEach((element, index) => {
              let name = '';
              element.owners.forEach((element, index) => {
                if (index == 0) {
                  name = name + element.first_name + ' ' + element.last_name;
                } else {
                  name = name + ' & ' + element.first_name + ' ' + element.last_name;
                }
              });
              let childrenList = [];
              element.groups.forEach((group) => {
                childrenList.push({
                  name: '-',
                  bg_color: group.bg_color,
                });
              });
              this.tree.push({
                name,
                owner_profile_image_path: element.owner_profile_image_path ? element.owner_profile_image_path : element.owners[0].profile_image_url,
                children: childrenList,
                owner_type: element.owner_type,
                position_value: element.position_value,
              });
            });
            if (data.data.length == 0) {
              this.showZeroState = true;
              this.changeDetector.detectChanges();
            }
            this.changeDetector.detectChanges();
          }

          //return security key generated by worker process

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          resolve(data);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair({}));
      }
    });
  }
  creteStructureTree(data, coloCOdeCOunt, owner_id, isUpdate = false) {
    let tree: MyTreeNode = {
      id: owner_id,
      name: '1',
      description: 'string',
      price: data.position_value,
      image: 'string',
      userListCount: data.owners.length,
      children: [],
      owner_type: data.owner_type,
      parentId: 1,
      owner_profile_image_path: data.owner_profile_image_path,
      css: 'border:none; background: transparent;box-shadow:none !important',
      isParent: true,
      is_active: data.is_active,
      isActive: false,
    };
    let image = '';
    let name = '';
    data.owners.forEach((element, index) => {
      if (index > 0) {
        name = name + ' & ';
      } else {
        image = element.profile_image_url;
      }
      name = name + element.first_name + ' ' + element.last_name;
    });
    let childList = [];
    data.groups.forEach((groupElement) => {
      let child = {
        name: groupElement.group_name,
        image: groupElement.group_image_url,
        css: `border:none; background:white;box-shadow:none !important;max-height: min-content; padding-bottom: 0px;max-width: 325px;`,
        isParent: false,
        id: 1,
        price: groupElement.position_value,
        userListCount: coloCOdeCOunt,
        color: groupElement.bg_color,
        parentId: 1,
        children: [],
        images: [],
        profile_image_url: groupElement.profile_image_url,
        asset_class: groupElement.asset_class,
        type: groupElement.type,
        is_active: groupElement.is_active,
        group_id: groupElement.group_id,
      };
      let assetsList = [];

      groupElement.assets.forEach((assetElement) => {
        assetsList.push({
          name: assetElement.asset_name,
          price: assetElement.position_value,
          vault_user_form_id: assetElement.vault_user_form_id,
          vault_user_form_user_id: assetElement.vault_user_form_user_id,
          img: assetElement.profile_image_url,
          owners: assetElement.owners,
          form_name: assetElement.asset_name,
          selected: false,
          is_active: assetElement.is_active,
        });
      });
      child.images = assetsList;
      childList.push(child);
    });

    tree.children = childList;
    tree.image = image;
    tree.name = name;
    if (isUpdate) {
      this.treeList[coloCOdeCOunt - 1] = tree;
    } else {
      this.treeList.push(tree);
    }

    this.changeDetector.detectChanges();
  }
  async getReprtDataByOwnerIdWorker(report_id, owner_id, index, isUpdate = false) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `owner-data-${Date.now()}-${Math.random()}`;
        const worker = new Worker(
          new URL('../../../../../../modules/reports/components/asset-map-container/get-report-data-by-owner-id.worker', import.meta.url),
          { type: 'module' }
        );
        this.activeWorkers.set(workerId, worker);

        let data = {
          token: '',
          url: '',
          report_execution_id: this.report_execution_id,
          owner_id: owner_id,
        };

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/report/report-execution-asset-map`;
        let date = new Date();
        worker.onmessage = ({ data }) => {
          if (data.status == 200 || data.status == 201) {
            this.creteStructureTree(data.data, index, owner_id, isUpdate);
          }

          //return security key generated by worker process

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          resolve(data);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair({}));
      }
    });
  }
  generateDataKeyPair(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }
}
